import React from "react";
import { Navbar, Row } from "react-bootstrap";
import SideBarSearchHook from "../../hook/search/SideBarSearchHook";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { BsArrowDownCircle } from "react-icons/bs";

const SideFilter = (props) => {
  const { t } = useTranslation();
  //var { selectedCategorySearch, ...otherProps } = this.props;
  const [category, brands] = SideBarSearchHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  // console.log('props');
  // console.log(props);
  return (
    <Navbar
      expand="sm"
      className="d-flex align-items-start navSideFilter"
      style={{ zIndex: 1000 }}
    >
      <div>
        <Navbar.Toggle aria-controls="basic-sideBar-nav" className="border-2">
          <BsArrowDownCircle /> Filter{" "}
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-sideBar-nav">
          <Row className="sideFilterRow">
            <div className="d-flex flex-column mt-2">
              {props.props?.hideCategory !== true ? (
                <>
                  <div className="filter-title">{t("main classification")}</div>
                  {category
                    ? category.map((el) => {
                        return (
                          <div key={el._id} className="d-flex mt-2 w-100">
                            <input
                              type="checkbox"
                              className="category"
                              value={el._id}
                              onClick={(e) =>
                                props.props.selectedCategorySearch(e)
                              }
                            />

                            <div
                              title={
                                Cookies.get("i18next") === "ar"
                                  ? el.nameAr
                                  : el.nameEn
                              }
                              className="filter-sub  "
                            >
                              {Cookies.get("i18next") === "ar"
                                ? el.nameAr
                                : el.nameEn}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </>
              ) : null}
            </div>

            {props.props?.hideBrands !== true ? (
              <div className="d-flex flex-column mt-2">
                <div className="filter-title mt-3">الماركة</div>

                {brands
                  ? brands.map((el) => {
                      return (
                        <div key={el._id} className="d-flex mt-2">
                          <input
                            type="checkbox"
                            className="brand"
                            value={el._id}
                            onClick={(e) => props.props.selectedBrandSearch(e)}
                          />
                          <div
                            style={{ width: "100px" }}
                            title={
                              Cookies.get("i18next") === "ar"
                                ? el.nameAr
                                : el.nameEn
                            }
                            className="filter-sub me-1 "
                          >
                            {Cookies.get("i18next") === "ar"
                              ? el.nameAr
                              : el.nameEn}
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            ) : null}

            <div className="filter-title mt-3">السعر</div>
            <div className="d-flex mt-2">
              <p className="filter-sub my-2">من:</p>
              <input
                className="m-1 "
                type="number"
                onChange={(e) => props.props.onChangeSetMinPrice(e)}
                value={props.minPrice}
                style={{ width: "50px", height: "26px" }}
              />
            </div>
            <div className="d-flex">
              <p className="filter-sub my-2">الي:</p>
              <input
                className="m-1"
                type="number"
                onChange={(e) => props.props.onChangeSetMaxPrice(e)}
                style={{ width: "50px", height: "26px" }}
              />
            </div>

            <button
              className="btn-save  mt-2 d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: settingsRes?.data?.primaryColor,
                width: "40%",
                marginRight: "6px",
                marginBottom:'15px',
                fontSize:"12px"
              }}
              onClick={() => props.props.search(0)}
            >
              <span> {t("search")} </span>
              <i className="fa fa-search p-2 d-flex justify-content-center"></i>
            </button>

            <button
              className="btn-save  mt-2 d-flex justify-content-center align-items-center"
              onClick={() => props.props.search(1)}
              style={{
                backgroundColor: settingsRes?.data?.primaryColor,
                width: "50%",
                marginRight: "6px",
                marginBottom:'15px',
                fontSize:"12px"
              }}
            >
              حذف الشروط
            </button>
          </Row>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default SideFilter;
